import { core } from "../../lib/api";

export type WhatsAppAnalyticsButton = { label: string; count: number };

export type WhatsAppAnalyticsTemplate = {
  template_id: string;
  name: string;
  sent: number;
  delivered: number;
  failed: number;
  replied: number;
  clicks: WhatsAppAnalyticsButton[];
};

export type WhatsAppAnalytics = {
  window: { start: string; end: string };
  kpis: {
    total: number;
    sent: number;
    delivered: number;
    failed: number;
    queued: number;
    replied: number;
    unique_replied: number;
    unique_contacts: number;
    response_rate: number;
  };
  per_day: { day: string; sent: number; delivered: number; failed: number; replied: number }[];
  templates: WhatsAppAnalyticsTemplate[];
};

export const whatsappAnalyticsApi = {
  summary: ({ start, end, campaignId }: { start: string; end: string; campaignId?: string }) => {
    const params = new URLSearchParams({ start_date: start, end_date: end });
    if (campaignId) params.set("campaign_id", campaignId);
    return core<WhatsAppAnalytics>(`/api/v1/whatsapp-campaigns/analytics?${params.toString()}`);
  },
};
